module.exports = __webpack_public_path__ + "media/images/sp/stores/suns/magazine/day02_07_stay-26933618e6c5c6d51d8198b2785b7788.jpg";